import BaseService from "./base-service";

export default class CalendarService extends BaseService {

    constructor() {
        super('calendars');
    }
}